import { createApp } from 'vue'
import { createVuetify } from 'vuetify'
import { createI18n } from 'vue-i18n';
import App from './App.vue'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createPinia } from 'pinia'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import router from './router'

const customTheme= {
  colors: {
    primary: '#1F8DE5'
  }
}

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
  },
  theme: {
    defaultTheme: 'customTheme',
    themes: {
      customTheme,
    },
  },
})

const messages = {
  ru: {
    $vuetify: {
      datePicker: {
        months: [
          'Январь', 'Февраль', 'Март', 'Апрель',
          'Май', 'Июнь', 'Июль', 'Август',
          'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
        ],
        weekdays: [
          'Воскресенье', 'Понедельник', 'Вторник',
          'Среда', 'Четверг', 'Пятница', 'Суббота'
        ],
      }
    }
  }
}

const i18n = createI18n({
  locale: 'ru',
  messages,
});

const pinia = createPinia()

createApp(App).use(vuetify).use(pinia).use(router).use(i18n).mount('#app')
